<ng-template sidenavContentArea></ng-template>
